import { createContext } from 'react';
import { UserContextInterface } from './UserContext.d';

const UserContext = createContext<UserContextInterface>({
  currentUser: null,
  setCurrentUser: () => null,
});

export default UserContext;
